import React, { useState } from 'react';
import { 
    Box,
} from '@mui/material';
import { Portal } from '@mui/base'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ReplayIcon from '@mui/icons-material/Replay';
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import UndoIcon from '@mui/icons-material/Undo';

import PermissionGuard from '../../contexts/PermissionContext';
import ControlButton from '../structure/ControlButton';
import MenuPopover from '../popover/MenuPopover';
import MenuListItem from '../menuitem/MenuListItem';
import BaseDivider from '../divider/BaseDivider';

import PdfConfigPopover from '../popover/PdfConfigPopover';
import CustomMetaPopover from '../popover/CustomMetaPopover';

export default function PdfConfigMenuBar(props) {
    const {
        addVisibleConfigRows,
        config,
        configRef,
        configOptions,
        contextRef,
        customRows,
        deleteConfig,
        handleChange,
        menuRef,
        openMenu,
        setConfigRows,
        setCustomRows,
        setMenuContent,
        submitConfig,
        undoConfig
    } = props

    const openRevertMenu = (e) => {
        openMenu(e)
        setMenuContent(
            <div style={{ width: '200px'}}>
                <MenuListItem 
                    label={'Revert To Last Saved Config'}
                    icon={<UndoIcon style={{ color: 'grey' }} />}
                    onClick={() => undoConfig('revert')}
                />
                <MenuListItem
                    label={'Reset To Original Config'}
                    icon={<SettingsBackupRestoreIcon  style={{ color: 'grey' }} />}
                    onClick={() => undoConfig('reset')}
                />
            </div>
        )
        
    }

    const openConfigMenu = (e) => {
        openMenu(e)
        setMenuContent(
            <PdfConfigPopover
                config={config}
                configOptions={configOptions}
                deleteConfig={deleteConfig}
                handleChange={handleChange}
            />
        )
    }

    const openCustomMetaMenu = (e) => {

        openMenu(e)
        setMenuContent(
            <CustomMetaPopover
                configRef={configRef}
                customRows={customRows}
                setConfigRows={setConfigRows}
                setCustomRows={setCustomRows}
            />
        )
    }

    const saveConfig = () => {
        const table = []
        const configObj = configRef.current.getSortedRows()
            .reduce((acc, item) => {
                if(!acc[item.configName]){
                    acc[item.configName] = [];
                }
                acc[item.configName].push(item.metadataName)
                return acc
            }, {})
        const contextObj = contextRef.current.getSortedRows()
            .reduce((acc, item) => {
                if(item.table){
                    table.push(item.configName)
                }
                acc[item.configName] = item.contextName
                return acc
            }, {})
        const customObj = customRows.reduce((acc, item) => {
            acc[item.metadataName] = item.customString
            return acc
        }, {})
        const body = {
            ...config,
            data: configObj,
            args: {
                ...config.args,
                customColumn: customObj
            },
            context: contextObj,
            table: table
        }
        submitConfig(body)
    }

    return (
        <React.Fragment>
            <Portal container={menuRef.current}>
                <ControlButton
                    title='Create custom metadata'
                    clicked={openCustomMetaMenu}
                >
                    <AttachMoneyIcon style={{fill: 'white'}} />
                </ControlButton>
                <ControlButton
                    title='Move visible metadata to config'
                    clicked={addVisibleConfigRows}
                >
                    <KeyboardDoubleArrowRightIcon style={{fill: 'white'}} />
                </ControlButton>
                <BaseDivider />
                <ControlButton
                    title='Save changes'
                    clicked={saveConfig}
                    // disabled={Object.keys(config).length > 0 ? false : true}
                >
                    <SaveIcon style={{fill: 'white'}} />
                </ControlButton>
                <PermissionGuard permission={['update:deliverables']}>
                <ControlButton
                    title='Revert to an older config'
                    clicked={openRevertMenu}
                    // disabled={Object.keys(config).length > 0 ? false : true}
                >
                    <Box
                        display="flex"
                        paddingLeft="5px"
                        justifyContent="center"
                        alignItems="center"
                        pr={0.3}
                    >
                        <ReplayIcon style={{fill: 'white'}} />
                        <ArrowDropDownIcon style={{fill: "white"}} sx={{ fontSize: 18, ml: -0.4 }}/>
                    </Box>
                </ControlButton>
                </PermissionGuard>
                <BaseDivider />
                <ControlButton
                    title='Configure deliverable'
                    clicked={openConfigMenu}
                    // disabled={Object.keys(config).length > 0 ? false : true}
                >
                    <SettingsIcon style={{fill: 'white'}} />
                </ControlButton>
            </Portal>
        </React.Fragment>
    );
}
